import { render, staticRenderFns } from "./boot-list.vue?vue&type=template&id=d1cebaf4&scoped=true"
import script from "./boot-list.vue?vue&type=script&lang=js"
export * from "./boot-list.vue?vue&type=script&lang=js"
import style0 from "./boot-list.vue?vue&type=style&index=0&id=d1cebaf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cebaf4",
  null
  
)

export default component.exports